<div *ngIf="!utils.isMobileOrTablet && files">

  <div *ngFor="let file of files; index as i">

    <h3>{{file.name}}</h3>
    <object *ngIf="safeEmbed(file.type) && pdfSrc[i]"  style="width: 100%; min-height: 600px" #pdfViewerOnDemand [data]="pdfSrc[i]"></object>
    <!-- fix safari on Big Sur/Montery: type="{{file.type}}" -->
   <!--<div *ngIf="files" style="width: 800px; height: 400px">
      <pdf-viewer [src]="pdfSrc[i]" [fit-to-page]="true" [render-text]="true" #pdfViewerOnDemand style="display: block;"></pdf-viewer>
    </div>-->

    <!--<div *ngIf="file.name">
      <span>{{file.type}} embed?: {{safeEmbed(file.type)}} {{file.getUrl}}</span>
      <br />
    </div>-->
  
    <div *ngIf="!safeEmbed(file.type) || isEdge">
      <i class="material-icons ic-warning">warning</i>
      &nbsp;{{translate.instant('FILE_PREVIEW.NOT_AVAILABLE')}}&nbsp;

      <a target="_self" [href]="file.downloadUrl" [download]="file.name"
        class="btn-link">{{translate.instant('FILE_PREVIEW.HERE')}}</a><br>
    </div>
</div>
<div *ngIf="utils.isMobileOrTablet && files">
  <div class="alert-info">
    <i class="material-icons ic-info">info</i>
    {{translate.instant('FILE_PREVIEW.MOBILE_INFO')}}&nbsp;
  </div>
  <br />
  <div *ngFor="let file of files">
    <div class="alert-info">
      <i class="material-icons ic-warning">info</i>
      <div>
        &nbsp;&nbsp;&nbsp;{{file.name}}&nbsp;
        <a target="_self" [href]="file.originalGetUrl" target="_blank" class="btn-link">
          {{translate.instant('FILE_PREVIEW.SEE')}}
        </a>
      </div>
    </div>
  </div>
</div>